import React from 'react'
import {
  Avatar,
  TwitterSolid,
  Facebook,
  InstagramSquare,
  Youtube,
  Reddit,
  LexisNexis,
  Weibo,
  Tiktok,
  MsnSolid,
  Bluesky,
  Podcasts
  // @ts-ignore
} from '@netbasequid/core'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { StreamData } from 'types/streamData'
import Domain from 'enums/Domain'
import StreamSymbol from 'enums/StreamSymbol'

type DomainIconProps = {
  streamData: StreamData
}

const DomainIcon = ({ streamData }: DomainIconProps) => {
  const theme = useDisplayTheme() as Theme
  const { dataStream, domain } = streamData

  if (dataStream === StreamSymbol.LXNX || dataStream === StreamSymbol.LXNXBRDCST) {
    return <LexisNexis fontSize={16} mode={theme} />
  }
  if (dataStream === StreamSymbol.PODCAST) {
    return <Podcasts fontSize={16} mode={theme} />
  }

  switch (domain) {
    case Domain.TWITTER:
      return <TwitterSolid fontSize={16} mode={theme} />
    case Domain.FACEBOOK:
      return <Facebook fontSize={16} mode={theme} />
    case Domain.INSTAGRAM:
      return <InstagramSquare fontSize={16} mode={theme} />
    case Domain.YOUTUBE:
      return <Youtube fontSize={16} mode={theme} />
    case Domain.WEIBO:
      return <Weibo fontSize={16} mode={theme} />
    case Domain.TIKTOK:
      return <Tiktok fontSize={16} mode={theme} />
    case Domain.REDDIT:
      return <Reddit fontSize={16} mode={theme} />
    case Domain.MSN:
      return <MsnSolid fontSize={16} mode={theme} />
    case Domain.BLUESKY:
      return <Bluesky fontSize={16} mode={theme} />
    default:
      return (
        <Avatar
          variant="circular"
          diameter="16px"
          mode={theme}
          alt={streamData.domain}
          fallbackStyles={{
            fontSize: '11px',
            fontWeight: 700
          }}
        />
      )
  }
}

export default DomainIcon
